// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  transition: 0.5s;
  pointer-events: initial;
  box-sizing: border-box;
  z-index: 2;
}

.hide-overlay {
  pointer-events: none;
  background: transparent;
  opacity: 0 !important;
  transition: 0.5s;
}

.overlay-container {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  backface-visibility: hidden;
  transform: translateZ(1);
  pointer-events: none;
  z-index: 4;
}

.hide-container {
  transition: 1s;
  opacity: 0;
  pointer-events: none;
}

.overlay-container h1 {
  font-size: 20px;
}

.button {
  cursor: pointer;
}

.button:hover {
  text-decoration: underline;
  color: #e8c15f;
}

.button:hover i {
  color: white;
}

.button-text {
  padding-left: 10px;
  padding-right: 10px;
}

hr {
  background: #666;
  height: 2px;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/motes-modal/motes-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,UAAA;AACJ;;AAEA;EACI,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,eAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EAEA,2BAAA;EACA,wBAAA;EACA,oBAAA;EACA,UAAA;AAAJ;;AAGA;EACI,cAAA;EACA,UAAA;EACA,oBAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,0BAAA;EACA,cAAA;AAAJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,WAAA;EACA,UAAA;AACJ","sourcesContent":[".modal-overlay {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0,0,0,.3);\n    transition: .5s;\n    pointer-events: initial;\n    box-sizing: border-box;\n    z-index: 2;\n}\n\n.hide-overlay {\n    pointer-events: none;\n    background: transparent;\n    opacity: 0 !important;\n    transition: .5s;\n}\n\n.overlay-container {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    // Fix blury issue with translating overlay with % in chrome\n    backface-visibility: hidden;\n    transform: translateZ(1);\n    pointer-events: none;\n    z-index: 4;\n}\n\n.hide-container {\n    transition: 1s;\n    opacity: 0;\n    pointer-events: none;\n}\n\n.overlay-container h1 {\n    font-size: 20px;\n}\n\n.button {\n    cursor: pointer;\n}\n\n.button:hover {\n    text-decoration: underline;\n    color: #e8c15f;\n}\n.button:hover i {\n    color: white;\n}\n\n.button-text {\n    padding-left: 10px;\n    padding-right: 10px;\n}\n\nhr {\n    background: #666;\n    height: 2px;\n    opacity: 1;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
